import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const getCurrentYear = () => {
  // “year of today’s date” has to be UTC minus 2 days - that should account for any users timezone
  return dayjs().utc().subtract(2, "day").year();
};

export default getCurrentYear;
